import { MdCopyright } from 'react-icons/md';

export const CopyRight = () => {
    return (
        <p className="footer__copyright">All rights reserved for L9LolSmurfs <MdCopyright className="footer__copyright-icon" /></p>
    );
};